module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAAAXNSR0IArs4c6QAAANNJREFUKBWVklEKwjAMhpPMY3gMXwVhIngRwQP4MtSnsRdv4E0UB4KvO8ausdYk2lFDB7Uw2ub/vzRNh5A79rcteHdVO9Julst9obn6OQFlg8aYD3J5zPb68RpDovLRLMG5A3hYaAyhA6JLu65ewRPPCpb3uvIANXg/JhITbxwgntrNsYkh1fSkYXgymCxb4aJY2ZNJypuCJLNqcgUzaLyTEX624d5RMFlepE8uiTvQTapBSHhIWq4NCCYzq8YeEwaSbnmicwrWmDxH4i1Z+4x/f4A3+cZG467E/twAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon_need.png
// module id = uYhM
// module chunks = 192